import React, { useState, useEffect } from 'react'
import Header from "../../components/layouts/Header"
import Footer from "../../components/layouts/Footer"
import { Order, OrderItem } from '../../lib/Types';
import { useAuthCustomer } from "../../components/hooks/useAuthCustomer";
import LoadingData from '../../components/loadding/LoadingData';

const Profile = () => {
    const { customer } = useAuthCustomer();
    const [loadingOrder, setLoadingOrder] = useState(false);
    const [order, setOrder] = useState<Order[]>([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const fetchOrder = async () => {
        try {
            if (!customer) return;

            setLoadingOrder(true);

            const params = new URLSearchParams({
                customer_id: customer.id.toString(),
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/order/history?${params.toString()}`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();
            console.log(json)
            setOrder(json.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingOrder(false);
        }
    };

    const handleSearchOrder = async () => {
        // if (!fromDate && !toDate) {
        //     alert("Vui lòng chọn ngày");
        //     return;
        // }

        try {
            setLoadingOrder(true);

            const params = new URLSearchParams();
            if (customer?.id) {
                params.append("customer_id", customer.id.toString());
            }
            if (fromDate) params.append("from_date", fromDate);
            if (toDate) params.append("to_date", toDate);

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/order/search-history?${params.toString()}`
            );

            const data = await res.json();
            setOrder(data.data);
        } catch (error) {
            console.error("Search order failed", error);
        } finally {
            setLoadingOrder(false);
        }
    };

    const formatVND = (value: number | string | null | undefined) => {
        const number = Number(value);

        return new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(isNaN(number) ? 0 : number);
    };

    useEffect(() => {
        fetchOrder();
    }, [customer]);

    return (
        <>
            <Header />

            <div className="max-w-[104rem] w-[96%] m-auto pt-24 pb-[12rem]">
                <div className="flex gap-4 items-center flex-wrap">
                    <p>Ngày đặt đơn:</p>
                    <div className="flex gap-4 items-center">
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className="border py-2 px-4 rounded-lg"
                        />
                        ~
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            className="border py-2 px-4 rounded-lg"
                        />
                    </div>
                </div>

                <button
                    onClick={handleSearchOrder}
                    className="bg-[#046DB3] text-white px-6 py-3 rounded-lg shadow hover:opacity-80 mt-6"
                >
                    Tìm kiếm
                </button>

                <div className="mt-8 overflow-auto">
                    <table className='w-full'>
                        <thead>
                            <tr>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Ngày đặt hàng</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Mã đơn</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Khung</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Màu</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Kích thước</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Số lượng</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Thành tiền</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Phí vận chuyển</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle">Tổng tiền</td>
                                <td className="bg-[#E6F0F7] p-4 border text-center align-middle leading-[1.2]">Phương thức <br />thanh toán</td>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingOrder ? (
                                <tr>
                                    <td colSpan={9} className="p-8 text-center">
                                        <LoadingData />
                                    </td>
                                </tr>
                            ) : order.length === 0 ? (
                                <tr>
                                    <td colSpan={9} className="p-8 text-center text-gray-500 text-2xl">
                                        Bạn chưa đặt đơn hàng nào
                                    </td>
                                </tr>
                            ) : (order.map((item) => {
                                const items = item.items ?? [];
                                const rowSpan = items.length || 1;

                                return items.length > 0 ? (
                                    items.map((orderItem, index) => (
                                        <tr key={`${item.id}-${orderItem.id}`}>
                                            {index === 0 && (
                                                <>
                                                    <td rowSpan={rowSpan} className="p-4 border text-center align-middle">
                                                        {item.create_at}
                                                    </td>
                                                    <td rowSpan={rowSpan} className="p-4 border text-center align-middle">
                                                        {item.id}
                                                    </td>
                                                </>
                                            )}

                                            <td className="p-4 border text-left align-middle">
                                                {orderItem.color?.color_name}
                                            </td>
                                            <td className="p-4 border text-left align-middle">
                                                {orderItem.frame?.frame_name}
                                            </td>
                                            <td className="p-4 border text-left align-middle">
                                                {orderItem.print_paper_size?.print_paper_size}
                                            </td>
                                            <td className="p-4 border text-right align-middle">
                                                {orderItem.quantity}
                                            </td>
                                            <td className="p-4 border text-right align-middle">
                                                {formatVND(orderItem.total_amount)}
                                            </td>

                                            {index === 0 && (
                                                <>
                                                    <td rowSpan={rowSpan} className="p-4 border text-right align-middle">
                                                        {formatVND(item.ship_fee)}
                                                    </td>
                                                    <td rowSpan={rowSpan} className="p-4 border text-right align-middle">
                                                        {formatVND(item.total_amount)}
                                                    </td>
                                                    <td rowSpan={rowSpan} className="p-4 border text-left align-middle text-2xl">
                                                        {item.payment_method?.payment_method_name}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    /* Trường hợp order KHÔNG có item */
                                    <tr key={item.id}>
                                        <td className="p-4 border text-center">{item.create_at}</td>
                                        <td className="p-4 border text-center">{item.id}</td>
                                        <td colSpan={5} className="p-4 border text-center text-gray-500">
                                            Không có sản phẩm
                                        </td>
                                        <td className="p-4 border text-right">{item.total_amount}</td>
                                        <td className="p-4 border text-left">
                                            {item.payment_method?.payment_method_name}
                                        </td>
                                    </tr>
                                );
                            })
                            )}
                        </tbody>
                    </table>
                </div>

            </div>

            <Footer />
        </>
    )
}

export default Profile